import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "antd/dist/antd.css";
import Loader from "./Loader";
import AddContactFJ from "./addContactFJ";
import ReactTooltip from "react-tooltip";
import {
  Layout,
  Menu,
  Breadcrumb,
  Table,
  Tag,
  Space,
  Avatar,
  Button,
  Input,
  DatePicker,
} from "antd";
import { Context } from "../../themeContext";
var dataTab = [];
var numberToAdd;
var dateColumnDisplay = "flex";
function Journal({ navbar, callClick, tabHeight }) {
  const compte = localStorage.getItem("compte");
  const posteCmk = localStorage.getItem("poste");
  const token = localStorage.getItem("AccessToken");
  const BackendURL = window.BackendURLCmk;
  const [stateObject, dispatch] = useContext(Context);

  const [data, setData] = useState([]);
  const [callColum, setCallColum] = useState("Tous");
  const [filteredInfo, setFilteredInfo] = useState({});
  const [value, setValue] = useState("");
  const [inputWidth, setInputWidth] = useState("0px");
  const [inputDateWidth, setInputDateWidth] = useState("none");
  const [loading, setLoading] = useState(false);
  const [showModelFJ, setShowModelFJ] = useState(false);
  var collegueTab;
  var contactsTab;

  function showModel(number) {
    setShowModelFJ(true);
    numberToAdd = number;
  }

  function fetchJournalTab() {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${posteCmk}`,
        config
        // config
      )
      .then((res) => {
        contactsTab = res.data.carnet_adresse;
        var config1 = {
          headers: {
            Authorization: token,
          },
        };
        const result1 = axios
          .get(
            `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3APIPROFIL?compte=${compte}&poste=${posteCmk}`,
            config1
            // config
          )
          .then((res) => {
            collegueTab = res.data.collegues;
            var dst;
            var config2 = {
              headers: {
                Authorization: token,
              },
            };
            const result2 = axios
              .get(
                `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${posteCmk}&date_debut=&date_fin=&filter=all`,
                config2
                // config
              )
              .then((res) => {
                var icon;
                var type;
                var iconType;
                dataTab = [];
                // console.log("eee", res.data.log_appel);
                for (var i = res.data.log_appel.length - 1; i >= 0; i--) {
                  if (
                    res.data.log_appel[i].disposition === "FAILED" ||
                    res.data.log_appel[i].disposition === "BUSY"
                  ) {
                    if (res.data.log_appel[i].src === posteCmk) {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-red-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                          ></path>
                        </svg>
                      );
                      type = "Émis";
                      iconType = "Appel échoué";
                    } else {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-red-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                          ></path>
                        </svg>
                      );

                      type = "Manqués";
                      iconType = "Appel échoué";
                    }
                  } else if (res.data.log_appel[i].disposition === "ANSWERED") {
                    if (res.data.log_appel[i].src === posteCmk) {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-blue-500 dark:text-blue-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          ></path>
                        </svg>
                      );
                      type = "Émis";
                      iconType = "Appel émis";
                    } else {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-green-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          ></path>
                        </svg>
                      );
                      type = "Reçus";
                      iconType = "Appel reçus";
                    }
                  } else if (
                    res.data.log_appel[i].disposition === "NO ANSWER"
                  ) {
                    if (res.data.log_appel[i].src === posteCmk) {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-gray-400 dark:text-blue"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          ></path>
                        </svg>
                      );
                      type = "Émis";
                      iconType = "Appel émis";
                    } else {
                      icon = (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-red-700"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          ></path>
                        </svg>
                      );
                      type = "Manqués";
                      iconType = "Appel manqué";
                    }
                  }
                  res.data.log_appel[i].src === posteCmk
                    ? (dst = res.data.log_appel[i].dst)
                    : (dst = res.data.log_appel[i].src);
                  dataTab.push({
                    key: i + 1,
                    callIcon: icon,
                    callIconType: iconType,
                    productimage:
                      collegueTab[
                        collegueTab.indexOf(
                          collegueTab.find((element) => element.poste === dst)
                        )
                      ] === undefined ||
                      collegueTab[
                        collegueTab.indexOf(
                          collegueTab.find((element) => element.poste === dst)
                        )
                      ].photo_poste_interne === "" ? (
                        <svg
                          className="h-full w-full text-gray-300 dark:text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          style={{
                            height: "40px",
                            borderRadius: "100%",
                            width: "72px",
                          }}
                        >
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                        </svg>
                      ) : (
                        <img
                          alt="avatar"
                          src={
                            collegueTab[
                              collegueTab.indexOf(
                                collegueTab.find(
                                  (element) => element.poste === dst
                                )
                              )
                            ].lien_photo_poste_interne
                          }
                          style={{
                            borderRadius: "100%",
                            height: "40px",
                            width: "40px",
                          }}
                        />
                      ),
                    productname:
                      collegueTab[
                        collegueTab.indexOf(
                          collegueTab.find((element) => element.poste === dst)
                        )
                      ] === undefined
                        ? contactsTab[
                            contactsTab.indexOf(
                              contactsTab.find(
                                (element) => element.tel_portable === dst
                              )
                            )
                          ] === undefined
                          ? dst
                          : contactsTab[
                              contactsTab.indexOf(
                                contactsTab.find(
                                  (element) => element.tel_portable === dst
                                )
                              )
                            ].nom_prenom
                        : collegueTab[
                            collegueTab.indexOf(
                              collegueTab.find(
                                (element) => element.poste === dst
                              )
                            )
                          ].nom,
                    addContact:
                      collegueTab[
                        collegueTab.indexOf(
                          collegueTab.find((element) => element.poste === dst)
                        )
                      ] === undefined
                        ? contactsTab[
                            contactsTab.indexOf(
                              contactsTab.find(
                                (element) => element.tel_portable === dst
                              )
                            )
                          ] === undefined
                          ? "no"
                          : "yes"
                        : "yes",
                    callType: type,
                    address: res.data.log_appel[i].calldate_start,
                    duree: res.data.log_appel[i].billsec,
                    phoneNumber: dst,
                    description: `My name is John Brown, I am 2 years old, living in New York No. Lake Park.`,
                  });
                }

                setData(dataTab);
                setLoading(true);
              })
              .catch((err) => {
                if (err == "Error: Request failed with status code 401") {
                  // var link = "/";
                  // window.location.replace(link);
                } else {
                  // console.log("AXIOS ERROR: ", err);
                }
              });
          })
          .catch((err) => {
            setLoading(false);
            if (err == "Error: Request failed with status code 401") {
              // var link = "/";
              // window.location.replace(link);
            } else {
              // console.log("AXIOS ERROR: ", err);
            }
          });
      })
      .catch((err) => {
        setLoading(false);
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });
  }
  useEffect(() => {
    fetchJournalTab();
  }, []);
  const openInput = () => {
    setInputWidth("100%");
    document.getElementById("inputSearchJournal").focus();
  };

  const openInputDate = () => {
    inputDateWidth === "none"
      ? setInputDateWidth("")
      : setInputDateWidth("none");
    inputDateWidth === "none"
      ? (dateColumnDisplay = "block")
      : (dateColumnDisplay = "flex");
  };

  const FilterByNameInput = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div className="dark:text-white" style={{ margin: "auto 3px auto 0" }}>
        Nom
      </div>
      <div
        className="inputIcon"
        style={{
          display: "flex",
          border: "1px solid #e6e8ec",
          borderRadius: "5px",
        }}
      >
        <div style={{ margin: "auto" }} onClick={() => openInput()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-4 dark:text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            style={{ color: "color: rgb(191, 192, 205)", margin: "auto" }}
          >
            {" "}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />{" "}
          </svg>
        </div>
        <Input
          id="inputSearchJournal"
          placeholder="Rechercher"
          value={value}
          onFocus={(e) => {
            setInputWidth("100%");
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              setInputWidth("0px");
            }
          }}
          onChange={(e) => {
            // console.log("tar", e.target.value);
            const currValue = e.target.value;
            setValue(currValue);
            const filteredData = dataTab.filter(
              (entry) =>
                entry.productname
                  .toUpperCase()
                  .includes(currValue.toUpperCase()) ||
                entry.phoneNumber
                  .toUpperCase()
                  .includes(currValue.toUpperCase())
            );
            setData(filteredData);
          }}
          style={{
            width: inputWidth,
            border: "0",
            backgroundColor: "transparent",
            float: "right",
            textAlign: "center",
          }}
        />
      </div>
    </div>
  );

  const FilterByDateInput = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div className="dark:text-white" style={{ margin: "auto 3px auto 0" }}>
        Date
      </div>
      <div
        className="inputDateIcon"
        style={{
          display: "flex",
          height: "30px",
          border: "1px solid #e6e8ec",
          borderRadius: "5px",
        }}
      >
        <div style={{ margin: "auto" }} onClick={() => openInputDate()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-4 dark:text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            style={{ color: "color: rgb(191, 192, 205)", margin: "auto" }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <DatePicker.RangePicker
          // showTime={{ format: "HH:mm:ss" }}
          format="YYYY-MM-DD"
          placeholder={["from", "to"]}
          style={{
            display: inputDateWidth,
          }}
          onChange={(e) => {
            if (e !== null) {
              const startDate = e[0]._d;
              const endDate = e[1]._d;
              const tabFiltre = dataTab;
              // console.log("gerr", startDate);
              // console.log("gerr2", endDate);

              const filteredData = tabFiltre.filter(
                (entry) =>
                  new Date(entry.address) >= startDate &&
                  new Date(entry.address) <= endDate
              );
              setData(filteredData);
            } else {
              setData(dataTab);
            }
          }}
        />
      </div>
    </div>
  );

  const FilterByTimeInput = <div className="dark:text-white">Durée</div>;

  const FilterByTypeInput = <div className="dark:text-white">{callColum}</div>;

  const columns = [
    {
      title: FilterByTypeInput,
      dataIndex: "name",
      key: "name",
      width: 80,
      minWidth: 30,
      borderRadius: 30,
      filters: [
        { text: "Manqués", value: "Manqués" },
        { text: "Émis", value: "Émis" },
        { text: "Reçus", value: "Reçus" },
      ],
      filteredValue: filteredInfo.name || null,
      onFilter: (value, record) => record.callType.includes(value),
      ellipsis: true,
      render: (text, call) => {
        return (
          <div className="tooltip w-full" style={{ width: "65px" }}>
            <span
              class="tooltiptext"
              style={{
                width: "60px",
                top: "-5px",
                left: "125%",
                fontSize: "xx-small",
              }}
            >
              {call.callIconType}
            </span>
            <div>{call.callIcon}</div>
          </div>
        );
      },
    },

    {
      title: FilterByNameInput,
      dataIndex: "name",
      width: 170,
      minWidth: 100,
      key: "nameC",
      render: (text, record) => {
        return (
          <div className="tooltip" style={{ color: "black" }}>
            <div
              data-offset={
                navbar
                  ? "{'top': 10, 'left': 1050}"
                  : "{'top': 10, 'left': 350}"
              }
              className="dark:text-white"
              style={{
                display: "flex",
                // margin: "auto",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={() =>
                dispatch({
                  type: "MAKE_CALL",
                  payload: {
                    type: "CALL",
                    number: record.phoneNumber,
                    nom: record.productname,
                    image: "",
                  },
                })
              }
            >
              <span class="tooltiptext">Appeler</span>

              {record.productimage}
              {/*<Avatar src={record.productimage}/> */}
              <div style={{ margin: "0 15px", width: "100%" }}>
                <div style={{ fontSize: "small", textAlign: "center" }}>
                  {record.productname}
                </div>
                <div style={{ fontSize: "small", textAlign: "center" }}>
                  {record.phoneNumber}
                </div>
              </div>
            </div>
          </div>
        );
      },
    },

    {
      title: FilterByTimeInput,
      dataIndex: "duree",
      width: 80,
      minWidth: 30,
      key: "duree",
      render: (text, record) => {
        return <div className="dark:text-white">{record.duree}</div>;
      },
    },
  ];

  const handleChange = (pagination, filters, sorter) => {
    // console.log("Various parameters", pagination, filters, sorter);
    filters.name !== null
      ? setCallColum(filters.name[0])
      : setCallColum("Tous");
    setFilteredInfo(filters);
  };

  return (
    <div>
      {loading ? (
        <div className="collegue">
          <Table
            locale={{ emptyText: " " }}
            columns={
              navbar
                ? columns.filter(
                    (column) =>
                      column.title !== FilterByTimeInput &&
                      column.title !== FilterByDateInput
                  )
                : columns
            }
            dat
            dataSource={data}
            // expandedRowRender={record => <p>{record.description}</p>}
            onChange={handleChange}
            scroll={{ y: navbar ? tabHeight : tabHeight + 65 }}
            style={{
              paddingLeft: navbar ? "0px" : "57px",
              backgroundColor: "transparent",
            }}
          />
          <AddContactFJ
            show={showModelFJ}
            close={() => setShowModelFJ(false)}
            fetchJournalTab={fetchJournalTab}
            numberToAdd={numberToAdd}
          />
        </div>
      ) : (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}
    </div>
  );
}

export default Journal;
